
































import _ from 'lodash';
import { Component, Vue, Prop } from 'vue-property-decorator';
import { AveragedRelativeBandPowers } from './MuseRecorder.vue';
import { line } from 'd3-shape';
import { scaleLinear } from 'd3-scale';
import { saveAs } from 'file-saver';

@Component
export default class Session extends Vue {
  @Prop({ default: [] })
  sessionData: AveragedRelativeBandPowers[];
  
  @Prop({ default: 800 })
  width: number;

  @Prop({ default: 500 })
  height: number;

  get series(): string[] {
    return Object.keys(this.sessionData[0] || {});
  }

  get xScale() {
    return scaleLinear()
      .domain([0, this.sessionData.length - 1])
      .range([0, this.width]);
  }

  get yScale() {
    return scaleLinear()
      .domain([0, 0.5])
      .range([this.height, 0]);
  }

  get lastSessionPointForSerie () {
    let lastSessionPoint = _.last(this.sessionData);
    return (serie) => {
      if ( lastSessionPoint && lastSessionPoint[serie] )
        return lastSessionPoint[serie];
      else
        return '-';
    }
  }

  private lineForSerie(serie: string): string | null {
    return line()(this.sessionData.map(
      (v, i) => [
        this.xScale(i),
        this.yScale(v[serie])
      ] as [number, number]
    ));
  }

  private saveAsJSON(): void {
    let blob = new Blob(
      [JSON.stringify(this.sessionData, null, 2)],
      {type: "application/json;charset=utf-8"}
    );
    let exportDate = new Date();
    let filename = `muse-session-${exportDate.toISOString()}.json` 
    saveAs(blob, filename);
  }
}
